import type { Dispatch } from 'react';
import type { Action, AppConfig, AppState, TenantBundle, WidgetInstance } from '@ce/core';

/**
 * What every widget is handed. Widgets never reach for globals: everything they
 * read arrives here, which is what lets the admin render the same components
 * against a draft config and lets tests render them against fixtures.
 */
export interface WidgetCtx {
  bundle: TenantBundle;
  state: AppState;
  dispatch: Dispatch<Action>;
  config: AppConfig;
  /** Content/engagement API origin. Empty means offline-only. */
  cmsUrl: string;
  /** Set by the admin's preview to outline the widget being edited. */
  highlightId?: string | null;
}

export interface WidgetProps {
  ctx: WidgetCtx;
  inst: WidgetInstance;
}

/** Reads a widget's props with a type. Sanitising already guaranteed the shape. */
export function propsOf<T>(inst: WidgetInstance): T {
  return inst.props as unknown as T;
}

export { hashText } from '@ce/core';
